import api from './apiCalls';

export const authAPI = {
  login: (credentials) =>
    api.post('/auth/login', credentials).then((r) => r.data.data),

  logout: () =>
    api.post('/auth/logout').catch(() => {}),   // best-effort

  me: () =>
    api.get('/auth/me').then((r) => r.data.data),
};
